import { isUndefined, some } from "lodash";

import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { UpdateCustomerPayload } from "components/CustomerModal/components/CustomerNotes/hooks";
import type { Customer } from "models";

type DeleteCustomerNotePayload = {
  customer_id: number;
  customer_note_id: number;
};

export const deleteCustomerNote = (customer: Customer, customer_note_id: number) => {
  if (!customer.notes) return;

  const noteIdx = customer.notes.findIndex(cn => cn.id === customer_note_id);
  if (noteIdx < 0) return;

  return { ...customer, notes: customer.notes.toSpliced(noteIdx, 1) };
};

export const useDeleteCustomerNoteMutation = () =>
  useTypedMutation<DeleteCustomerNotePayload, void>({
    mutationFn: async ({ customer_note_id }) => {
      await ApiInstance.post("/customers/note/delete", { customer_note_id }, ENV.dealerBaseURL);
    },
    onSuccess: ({ customer_id, customer_note_id }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      const updatedCustomer: UpdateCustomerPayload = {
        ...(appointment.customer_owner?.id === customer_id && { customer_owner: deleteCustomerNote(appointment.customer_owner, customer_note_id) }),
        ...(appointment.customer_driver?.id === customer_id && { customer_driver: deleteCustomerNote(appointment.customer_driver, customer_note_id) }),
        ...(appointment.customer_contract?.id === customer_id && { customer_contract: deleteCustomerNote(appointment.customer_contract, customer_note_id) })
      };

      if (!Object.keys(updatedCustomer).length || some(updatedCustomer, isUndefined)) return;
      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, ...updatedCustomer });
    }
  });
